import { Button } from "../../../../components/core/basic/Button";
import { useFetch } from "../../../../hooks/api";
import { Badge, Col } from "react-bootstrap";
import { Link } from "@tanstack/react-router";
import { useAppSelector } from "../../../../redux/hooks";
import { VStack } from "../../../../../styled-system/jsx";
import { useSimpleCan } from "../../../../config/casl/casl";
import { useTranslation } from "react-i18next";

const AudienceCard = ({ audience, setShowAudienceForm }) => {
  const { t } = useTranslation(["amc"]);
  const {
    audience_template_name: audienceName,
    audience_display_name,
    audience_description,
    audience_byline,
    recommended_tags,
  } = audience;
  const showFsiBadge = recommended_tags?.includes("FSI");
  const requiresFirstPartyData = recommended_tags?.includes("First Party Data");
  const { organization_id: orgId } = useAppSelector((state) => state.user);
  const userCanCreateAmcAudiences = useSimpleCan("create", "AMCAudience");

  const { data: dataLinks } = useFetch(
    ["datalinks", orgId],
    "/amc/datalink/",
    {},
    {
      enabled: requiresFirstPartyData,
      select: (res) => res.data.results,
    },
  );

  return (
    <Col xs={12} md={6} className="p-5">
      <div className="border h-100" style={{ padding: "16px 18px", borderRadius: "6px" }}>
        <div className="d-flex flex-column gap-2 justify-content-between h-100">
          <div>
            <h4 className={`my-0 d-flex gap-1 px-3 py-0`} style={{ fontWeight: 600, fontSize: "18px" }}>
              <div>
                {audience_display_name}
                {showFsiBadge && (
                  <div>
                    <Badge
                      className={`badge bg-trellis-purple w-auto mb-3 fs-5`}
                      style={{
                        borderRadius: "5px",
                      }}
                    >
                      {t(($) => $.amc["FSI"])}
                    </Badge>
                  </div>
                )}
                {requiresFirstPartyData && (
                  <div>
                    <Badge
                      className={`badge bg-trellis-purple w-auto mb-3 fs-5`}
                      style={{
                        borderRadius: "5px",
                      }}
                    >
                      {t(($) => $.amc["First Party Data"])}
                    </Badge>
                  </div>
                )}
                <span
                  style={{ fontWeight: 400, lineHeight: 1.4, fontSize: "13px", marginTop: "-3px" }}
                  className={`fst-italic  mb-3 d-block`}
                >
                  {audience_byline}
                </span>
              </div>
            </h4>

            <p className="fs-5 p-3" style={{ minHeight: "50px" }}>
              {audience_description}
            </p>
          </div>
          <div className="d-flex justify-content-center">
            {requiresFirstPartyData && dataLinks?.length === 0 && (
              <VStack>
                <Link className="fs-4" to="/user/amc/configuration">
                  {t(($) => $.amc["First Party Data Connections"])}
                </Link>
                <p className="pt-3 fs-5">{t(($) => $.amc["This audience requires first party data to be created."])}</p>
              </VStack>
            )}
            {(!requiresFirstPartyData || dataLinks?.length > 0) && (
              <Button
                onPress={() => {
                  setShowAudienceForm(audienceName);
                }}
                isDisabled={!userCanCreateAmcAudiences}
              >
                {t(($) => $.amc["Create a New Audience"])}
              </Button>
            )}
          </div>
        </div>
      </div>
    </Col>
  );
};

export default AudienceCard;
